import React, { useEffect, useRef, useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { Picker } from "@react-native-picker/picker";  // https://www.npmjs.com/package/@react-native-picker/picker
import { Feather } from "@react-native-vector-icons/feather";
import Button from "components/Partials/Buttons";
import DatePicker from "components/Partials/DatePicker";
import { patientFields, genderTypes } from "./PatientDetails";
import PatientProfileImage from "components/Partials/PatientProfileImage.js";
import TextInputRef from "components/Partials/TextInputRef";
import formRefs from "components/helpers/formrefs";

const PatientEditForm = ({ patientData, onCancel, onSave, containerStyle }) => {
  const _theme = window.main.theme;
  // const [formValues, formSetValues] = useState({ ...patientData });  // ⬅ Shallow copy of original
  const patientFormRefs = useRef(new formRefs());

  const DropdownField = ({ fieldObj }) => {
    const options = selectKeyOptions[fieldObj.selectOptionsKey];
    const [selVal, selSetVal] = useState(patientData[fieldObj.selectValueKey]||0);
    const onChange = (val)=>{
      patientFormRefs.current.set(fieldObj.selectValueKey, Number(val));  // Update the FormRef
      selSetVal(Number(val)||0);
    }
    const _ref = useRef();
    patientFormRefs.current.create(fieldObj.selectValueKey,_ref,patientData[fieldObj.selectValueKey]);
    useEffect(() => {
      patientFormRefs.current.create(fieldObj.selectValueKey,_ref,patientData[fieldObj.selectValueKey]);
      patientFormRefs.current.set(fieldObj,fieldObj.selectValueKey?patientData[fieldObj.selectValueKey]:"");
    }, []);
    return (
      // <Picker ref={_ref} selectedValue={fieldObj.selectValueKey?patientData[fieldObj.selectValueKey]:""} onValueChange={onChange} style={{minHeight:36,fontSize:16,width:"100%"}}>
      <Picker ref={_ref} selectedValue={selVal} onValueChange={onChange} style={{minHeight:36,fontSize:16,width:"100%",borderColor:"#cccccc",borderRadius:_theme.inputBorderRadius}}>
        <Picker.Item label={`-- Select One --`} value="0" />
        {options.map(opt => (
          <Picker.Item key={opt.id||opt.value||opt.name} label={opt.name||opt.label} value={opt.id||opt.value||opt.name} />
        ))}
      </Picker>
    );
  };

  const DateFormField = ({ fieldObj }) => {
    const [dpOpenState, dpOpenSetState] = useState(false);
    const [selVal, selSetVal] = useState(!!patientData[fieldObj.key]?window.main.lib.dateFormat(patientData[fieldObj.key]):"");
    const onChange = (val)=>{
      patientFormRefs.current.set(fieldObj.key, !!val?window.main.lib.dateFormat(val):"");  // Update the FormRef
      selSetVal(!!val?window.main.lib.dateFormat(val):"");
    }
    const openDatePicker = () => { dpOpenSetState(true); };
    const _ref = useRef();
    return (
      <DatePicker dateValue={selVal} openState={dpOpenState} openSetState={dpOpenSetState} onChange={onChange} containerStyle={{position:"relative",width:"100%"}} childContainerStyle={{position:"relative",width:"100%"}} pickerContainerStyle={{transform:"translate(0px,38px)"}} allowBlank={true}>
        <TextInputRef ref={_ref} formrefs={patientFormRefs.current} datakey={fieldObj.key} textValue={selVal} onFocus={openDatePicker} style={{borderWidth:1,borderColor:"#cccccc",backgroundColor:"#ffffff",borderRadius:_theme.inputBorderRadius,padding:8,fontSize:16,width:"100%"}} />
      </DatePicker>
    );
  };

  const TextFormField = ({ fieldObj }) => {
    const _ref = useRef();
    return (
      <TextInputRef ref={_ref} formrefs={patientFormRefs.current} datakey={fieldObj.key} textValue={patientData[fieldObj.key]||""} style={{borderWidth:1,borderColor:"#cccccc",backgroundColor:"#ffffff",borderRadius:_theme.inputBorderRadius,padding:8,fontSize:16,width:"100%"}} />
    );
  };


  const fetchBreeds = async () => {
    try {
      if (!!Number(patientData.species_id)) {
        window.main.lib.setLoadingState(true);
        const breedsResult = await window.main.axios.get(window.main.api.getBreeds.replace("{species_id}",patientData.species_id));
        breedsSetList(breedsResult.data);
      }
    } catch (err) {
      window.main.lib.setStatusState(window.main.lib.parseErrorMessage(err));
    } finally {
      window.main.lib.setLoadingState(false);
    }
  };

  const fetchDropdowns = async () => {
    try {
      const speciesResult = await window.main.axios.get(window.main.api.getSpecies);
      speciesSetList(speciesResult.data);
      if (!!Number(patientData.species_id)) {
        await fetchBreeds();
      }
    } catch (err) {
      console.log("Function: fetchDropdowns -> Error:",err);
      window.main.lib.setStatusState(window.main.lib.parseErrorMessage(err));
    } finally {
      window.main.lib.setLoadingState(false);
    }
  };

  const handleEditSave = () => {
    const payload = patientFormRefs.current.getAll();
    payload.patient_id = patientData.patient_id;
    console.log("patientData =", patientData);
    console.log("payload =", payload);
    onSave(payload);
  };

  // Auto detect if fetch dropdown data then use Hard coded if not fetched.
  useEffect(() => {
    window.main.lib.setLoadingState(true);
    fetchDropdowns();
  }, []);

  // Dropdown options state
  const [speciesList, speciesSetList] = useState([]);
  const [breedsList, breedsSetList] = useState([]);
  const selectKeyOptions = {
    speciesList: speciesList,
    breedsList: breedsList,
    gendersList: genderTypes(),
  };
  const editingFields = patientFields().filter(f => f.isEditable);

  return (
    <View style={{backgroundColor:_theme.colors.mode.containerBackgroundColor,borderRadius:_theme.borderRadius,flexDirection:"column",minHeight:540,minWidth:300,padding:24,position:"relative",width:"100%",...window.main.theme.boxShadowStyle,...containerStyle}}>
      <TouchableOpacity onPress={onCancel} style={{position:"absolute",right:12,top:12,zIndex:10}} accessibilityRole="button" accessibilityLabel="Cancel Editing">
        <Feather name="x" size={24} color={_theme.colors.mode.textColor} style={{cursor:"pointer",padding:4}} />
      </TouchableOpacity>
      <View style={{flexDirection:"row",alignItems:"flex-start",marginBottom:24,width:"100%"}}>
        <PatientProfileImage profile_image_id={patientData.profile_image_id} style={{width:72,height:72,marginRight:0}} />
        <View style={{alignItems:"flex-start",flex:1,flexDirection:"row",justifyContent:"space-between",marginLeft:20,marginTop:4}}>
          <Text style={{color:_theme.colors.mode.textColor,flexShrink:1,fontSize:22,fontWeight:"bold",marginRight:12}} numberOfLines={1} ellipsizeMode="tail">
            {patientData.name}
          </Text>
        </View>
      </View>
      <View style={{flexDirection:"column",alignItems:"flex-start",justifyContent:"flex-start",width:"100%",zIndex:2}}>
        {editingFields.map((fieldObj,rowIndex) => {
          return (
            <View key={fieldObj.key} style={{marginBottom:16,width:"100%",zIndex:(editingFields.length-rowIndex)}}>
              <Text style={{color:_theme.colors.mode.textColor,fontWeight:"600",fontSize:14,marginBottom:4}}>
                {fieldObj.label}{!!fieldObj.isOptional && <Text style={{marginLeft:12,fontWeight:"400"}}>(Optional)</Text>}
              </Text>
              <View style={{flexDirection:"row",alignItems:"flex-start",width:"100%",justifyContent:"flex-start"}}>
                {(!!fieldObj.selectOptionsKey) ? (
                  <DropdownField key={fieldObj.key} fieldObj={fieldObj} />
                ) : (!!fieldObj.isDate) ? (
                  // <DateFormField key={fieldObj.key} formValues={formValues} field={fieldObj} handleChange={val=>formSetValues(prev=>({...prev,[fieldObj.key]:val}))} />
                  <DateFormField key={fieldObj.key} fieldObj={fieldObj} />
                ) : (
                  // <TextFormField key={fieldObj.key}  formValues={formValues} field={fieldObj} handleChange={val=>formSetValues(prev=>({...prev,[fieldObj.key]:val}))} />
                  <TextFormField key={fieldObj.key} fieldObj={fieldObj} />
                )}
              </View>
            </View>
          );
        })}
      </View>
      <View style={{flexDirection:"row",justifyContent:"center",marginTop:20,width:"100%",zIndex:1}}>
        <Button text="Cancel" type="secondary" style={{marginRight:12,minWidth:70,maxWidth:100,height:32,paddingVertical:4,fontSize:14}} onPress={onCancel} accessibilityLabel="Cancel Editing" />
        <Button text="Update Patient" type="primary" style={{minWidth:70,maxWidth:150,backgroundColor:"hsla(135,35%,27%,1.00)",color:"#161414ff",height:32,paddingVertical:4,fontSize:14}} onPress={handleEditSave} accessibilityLabel="Save Changes" />
      </View>
    </View>
  );
};

export default PatientEditForm;
